import {Business, CurrentUser, MenuItem, MenuSection} from "../../../types/Types";
import {Form} from "react-bootstrap";
import * as React from "react";
import {useState} from "react";
import {useNavigate, useParams} from "react-router";
import TextField from "../../../components/form/TextField";
import LocationSelector from "../../../components/form/LocationSelector";
import NumberField from "../../../components/form/NumberField";
import {useEffect} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSort} from "@fortawesome/free-solid-svg-icons";
import {collection, getDocs, limit, orderBy, query, where} from "@firebase/firestore";
import {db, functions} from "../../../firebase/FirebaseProvider";
import {httpsCallable} from "@firebase/functions";

interface Props {
  currentUser: CurrentUser,
  business: Business | undefined,
}

function MenuItemUpdatePage(props: Props) {
  const navigate = useNavigate();
  const [updating, setUpdating] = useState<boolean>(false);

  const [menuItem, setMenuItem] = useState<MenuItem>();

  const [location, setLocation] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [subDescription, setSubDescription] = useState<string>("");
  const [price, setPrice] = useState<number>();
  const [order, setOrder] = useState<number>();

  const { sectionId: menuSectionId } = useParams();
  const { itemId: itemId } = useParams();

  const updateMenuItem = async () => {
    if(!props.business) {
      return
    }
    setUpdating(true);

    const updateMenuItem = httpsCallable(functions, 'updateMenuItem');
    await updateMenuItem({
      business: props.business.id,
      location: location,
      menuSectionId: menuSectionId,
      menuItemId: itemId,
      description: description,
      subDescription: subDescription,
      price: price,
      order: order,
    }).then(() => {
      navigate("/menu");
    });
  };

  useEffect(() => {(async () => {
    const menuItemsCollection = query(
        collection(db, 'menu-items'),
        where("id", "==", itemId),
        orderBy("createdAt", "desc"),
        limit(1),
    );
    const menuItemsSnapshot = await getDocs(menuItemsCollection);
    menuItemsSnapshot.forEach((doc) => {
      const menuItemToSet = doc.data() as MenuItem;
      setMenuItem(menuItemToSet);
      setDescription(menuItemToSet.description);
      setSubDescription(menuItemToSet.subDescription);
      setPrice(menuItemToSet.price);
      setOrder(menuItemToSet.order);
    });
  })();
  }, []);

  return (
      <div>
        <Form className={"mb-3"}>
          <LocationSelector business={props.business} setValue={setLocation}/>
          <TextField label={"Description"} subLabel={"For example: Mahou"} value={description} setValue={setDescription} required={true}/>
          <TextField label={"Additional Info"} subLabel={"For example: 330ml bottle"} value={subDescription} setValue={setSubDescription} required={false}/>
          <NumberField label={"Price"} subLabel={"For example: 4.50"} unit={<>€</>} step={0.01} placeholder={""} required={true} value={price} setValue={setPrice} />
          <NumberField label={"Order"} subLabel={"The items's position in the section."} unit={<FontAwesomeIcon icon={faSort}/>} placeholder={""} step={1} value={order} setValue={setOrder} required={true}/>
        </Form>
        {!updating && <div className={"primary-button"} onClick={() => updateMenuItem()}>Update Menu Section</div>}
        {updating && <div className={"primary-button"}>Updating...</div>}
      </div>
  );
}

export default MenuItemUpdatePage;